/**
 * @generated SignedSource<<d9c2767ff05fe3587877b984aa6a15e9>>
 * @relayHash c389178add8c5be755e636b08466a267
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b7a89468a1d975fb76c26902518fa1889b03a497c7b56544c5ca718ace781e04

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { main_EditionAwarenessTrialModalQuery } from './main_EditionAwarenessTrialModalQuery.graphql';

const node: PreloadableConcreteRequest<main_EditionAwarenessTrialModalQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "b7a89468a1d975fb76c26902518fa1889b03a497c7b56544c5ca718ace781e04",
    "metadata": {},
    "name": "main_EditionAwarenessTrialModalQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
